import { render, staticRenderFns } from "./CustomerDiscountScheduler.vue?vue&type=template&id=3c83400a"
import script from "./CustomerDiscountScheduler.vue?vue&type=script&lang=js"
export * from "./CustomerDiscountScheduler.vue?vue&type=script&lang=js"
import style0 from "./CustomerDiscountScheduler.vue?vue&type=style&index=0&id=3c83400a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports